import { render, staticRenderFns } from "./SettingsMenuCard.vue?vue&type=template&id=6141ac80&scoped=true"
import script from "./SettingsMenuCard.vue?vue&type=script&lang=js"
export * from "./SettingsMenuCard.vue?vue&type=script&lang=js"
import style0 from "./SettingsMenuCard.vue?vue&type=style&index=0&id=6141ac80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6141ac80",
  null
  
)

export default component.exports